import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBOVendorRequest.ContactInformationSection', {
    contactInformationHeader: 'Vendor information',
    displayNameAs: 'Display name as',
    displayNameAsPlaceholder: 'Enter display name',
    companyName: 'Company',
    companyNamePlaceholder: 'Enter company name',
    title: 'Title',
    titlePlaceholder: 'Mr.',
    givenName: 'First name',
    givenNamePlaceholder: 'Enter first name',
    middleName: 'Middle name',
    middleNamePlaceholder: 'Enter middle name',
    familyName: 'Last name',
    familyNamePlaceholder: 'Enter last name',
    suffix: 'Suffix',
    suffixPlaceholder: 'Jr',
    email: 'Email',
    emailPlaceholder: 'Enter email',
    website: 'Website',
    websitePlaceholder: 'Enter website URL in format https://www.intuit.com',
    primaryPhone: 'Phone',
    primaryPhonePlaceholder: 'Enter phone',
    mobilePhone: 'Mobile',
    mobilePhonePlaceholder: 'Enter mobile phone',
    fax: 'Fax',
    faxPlaceholder: 'Enter fax',
});
